export const calendarEventTemplateColumnValidation = {
  allDayEvent: ['TRUE', 'FALSE'],
  addGoogleMeet: ['TRUE', 'FALSE'],
  visibility: ['default', 'private', 'public', 'confidential'],
  eventType: [
    'default',
    'birthday',
    'focusTime',
    'fromGmail',
    'outOfOffice',
    'workingLocation',
  ],
};
